// CANONICAL COPY (GH #7115). src/constants/obligations/obl-ski-control-effectiveness-reporting.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-ski-control-effectiveness-reporting',
  title: 'Report IS control effectiveness to management and customer',
  description:
    "Regularly monitor and evaluate the effectiveness of implemented information security controls. Findings shall be reported to the supplier's own management and — where relevant to the delivery of services — also communicated to the customer. The report must identify areas for further risk mitigation and confirm the current status of controls.",
  category: 'governance',
  scfIds: ['SCF-MSS-005', 'SCF-GOV-004'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'Control effectiveness reporting procedure is published',
    },
    { type: 'document-within-sla', description: 'Procedure review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
